<template>
  <v-dialog persistent max-width="600px" v-model="showDialog">
    <v-card class="glass-dialog-card">
      <v-card-title class="text-h5 font-weight-bold justify-center pb-4 pt-5">
        <v-icon left large class="mr-3">mdi-face-agent</v-icon>
        Kundeninteraktion
      </v-card-title>

      <v-card-text v-if="initializing" class="d-flex justify-center align-center" style="min-height: 350px">
        <v-progress-circular indeterminate color="primary" size="64" width="5">
          <v-icon>mdi-sync</v-icon>
        </v-progress-circular>
      </v-card-text>

      <v-stepper v-else v-model="step" class="transparent-stepper">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1">Trainer</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 2" step="2">Kunde</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3">Details</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1" class="pt-6">
            <div v-if="!employeeInfos._id">
              <user-search label="Trainer auswählen..." :value="employeeInfos._id" ignoreRights instructor @update="updateEmployee"></user-search>
            </div>
            <div v-else class="text-center">
              <v-chip large color="primary" class="mb-4">
                <v-icon left>mdi-account-check</v-icon>
                {{ employeeInfos.firstName }} {{ employeeInfos.lastName }}
              </v-chip>
              <v-btn text @click="employeeInfos = { _id: null }">
                <v-icon left small>mdi-swap-horizontal</v-icon>
                Trainer wechseln
              </v-btn>
            </div>
            <v-card-actions class="mt-6">
              <v-btn text @click="close">Schließen</v-btn>
              <v-spacer></v-spacer>
              <v-btn rounded large color="primary" @click="nextStep(1)">Weiter</v-btn>
            </v-card-actions>
          </v-stepper-content>

          <v-stepper-content step="2" class="pt-6">
            <div v-if="!customerInfos._id">
              <user-search label="Kunde auswählen..." :value="customerInfos._id" ignoreRights @update="updateCustomer"></user-search>
              <div class="text-center mt-3">
                <v-btn text color="primary" @click="createRoodyAccount">
                  <v-icon left>mdi-account-plus-outline</v-icon>
                  Neuen roody Account erstellen
                </v-btn>
              </div>
            </div>
            <div v-else class="text-center">
              <v-chip large color="secondary" class="mb-4">
                <v-icon left>mdi-account-check</v-icon>
                {{ customerInfos.firstName }} {{ customerInfos.lastName }}
              </v-chip>
              <v-btn text @click="customerInfos = { _id: null }">
                <v-icon left small>mdi-swap-horizontal</v-icon>
                Kunde wechseln
              </v-btn>
            </div>
            <v-card-actions class="mt-6">
              <v-btn text @click="prevStep">Zurück</v-btn>
              <v-spacer></v-spacer>
              <v-btn rounded large color="primary" @click="nextStep(2)">Weiter</v-btn>
            </v-card-actions>
          </v-stepper-content>

          <v-stepper-content step="3" class="pt-4">
            <v-select
              v-model="reason"
              :items="items"
              item-text="text"
              item-value="value"
              label="Was wurde besprochen?"
              outlined
              prepend-inner-icon="mdi-format-list-bulleted"></v-select>
            <v-select
              v-model="location"
              :items="itemsLocation"
              label="Wo fand die Besprechung statt?"
              outlined
              prepend-inner-icon="mdi-map-marker-outline"
              class="mt-4"></v-select>

            <div v-if="showAppointmentFields">
              <label class="font-weight-medium">Termin abgemacht?</label>
              <v-radio-group v-model="appointmentMade" row class="mt-1">
                <v-radio label="Ja" value="ja"></v-radio>
                <v-radio label="Nein" value="nein"></v-radio>
              </v-radio-group>

              <v-row v-if="appointmentMade === 'ja'">
                <v-col cols="12" sm="6">
                  <v-text-field v-model="appointmentDate" label="Datum" type="date" outlined prepend-inner-icon="mdi-calendar"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="appointmentTime" label="Uhrzeit" type="time" outlined prepend-inner-icon="mdi-clock-outline"></v-text-field>
                </v-col>
              </v-row>
            </div>

            <div v-if="reason === 'Zusatzpakete pushen'">
              <label class="font-weight-medium mb-2 d-block">Welche Pakete wurden besprochen?</label>
              <v-select
                v-model="selectedPackages"
                :items="zusatzpaketItems"
                label="Pakete auswählen"
                multiple
                outlined
                chips
                deletable-chips></v-select>
            </div>

            <div v-if="reason === 'Kursempfehlung'">
              <course-search-studio
                :key="courseKey + '-courseSearch'"
                ignoreRights
                label="Kurs empfehlen..."
                @update="addCourse"></course-search-studio>
              <v-chip v-if="recommendedCourse" class="mt-3" close @click:close="recommendedCourse = null">
                <v-icon left>mdi-weight-lifter</v-icon>
                {{ recommendedCourse.name }}
              </v-chip>
            </div>

            <v-textarea v-model="notes" label="Notizen" outlined prepend-inner-icon="mdi-text-box-outline" class="mt-4" rows="3"></v-textarea>
            <v-switch
              v-if="reason && reason.includes('49')"
              v-model="shareContactInfo"
              label="Kontaktdaten dürfen mit Allianz geteilt werden"
              class="mt-0"></v-switch>
            <v-card-actions class="mt-4">
              <v-btn text @click="prevStep">Zurück</v-btn>
              <v-spacer></v-spacer>
              <v-btn rounded large :loading="saving" @click="save" color="primary">
                <v-icon left>mdi-content-save</v-icon>
                Speichern
              </v-btn>
            </v-card-actions>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
    <register
      @register="newAccountRegistered()"
      :auto-login="false"
      :requirePassword="false"
      @close="showRegisterDialog = false"
      :active="showRegisterDialog"></register>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex"
import api from "@/api"
import register from "@/views/launchScreen/register.vue"
import userSearch from "@/components/userSearch.vue"
import courseSearchStudio from "@/components/courseSearchStudio.vue" // Importieren
import userService from "@/services/userService"

export default {
  components: { userSearch, register, courseSearchStudio }, // Hinzufügen
  data() {
    return {
      initializing: false,
      userService,
      showRegisterDialog: false,
      saving: false,
      step: 1,
      items: [
        { text: "Weiteres (kein Statistik-Eintrag)", value: "Weiteres" },
        { text: "MeScan CHF 49.- Gutschein", value: "MeScan CHF 49.- Gutschein" },
        { text: "Bring a Friend", value: "Bring a Friend" },
        { text: "Kursempfehlung", value: "Kursempfehlung" },
        { text: "Milon Einführung vereinbaren", value: "Milon Einführung vereinbaren" },
        { text: "Neuer Plan vereinbaren", value: "Neuer Plan vereinbaren" },
        { text: "Zusatzpakete pushen", value: "Zusatzpakete pushen" },
      ],
      itemsLocation: ["Trainingsfläche", "Empfang", "Aufenthaltszone (Lounge)"],
      shareContactInfo: false,
      showDialog: false,
      reason: null,
      location: null,
      notes: null,
      employeeInfos: { _id: null },
      customerInfos: { _id: null },

      // --- NEUE DATENFELDER ---
      appointmentMade: null, // 'ja' oder 'nein'
      appointmentDate: null, // z.B. '2025-09-20'
      appointmentTime: null, // z.B. '14:30'
      zusatzpaketItems: [
        "Getränke",
        "Hydrojet",
        "Kinderhort",
        "Milon",
        "Pelvix Power-Stuhl",
        "Power Plate",
        "Solarium",
        "Tücherservice",
        "Wellness/Spa",
        "Wellness/Spa plus",
        "mescan - uneingeschränkt",
      ],
      selectedPackages: [], // Array für ausgewählte Pakete
      recommendedCourse: null, // Objekt für den ausgewählten Kurs
      courseKey: 0, // Für das Neuladen der Suchkomponente
    }
  },
  computed: {
    ...mapGetters("studioStore", ["getSelectedEmployee"]),
    ...mapGetters("panelStore", { selectedCustomer: "getSelectedCustomer" }),
    // --- NEUE COMPUTED PROPERTY ---
    showAppointmentFields() {
      const reasonsWithAppointment = ["MeScan CHF 49.- Gutschein", "Milon Einführung vereinbaren", "Neuer Plan vereinbaren"]
      return this.reason && reasonsWithAppointment.includes(this.reason)
    },
  },
  created() {
    if (this.userService?.getStudio()?.code === "buelach") this.items.push("um Google Bewertung gebeten")
  },
  methods: {
    async setVisible(customerId = null) {
      this.showDialog = true
      this.initializing = true
      try {
        await this.reset()

        const promises = []
        if (this.getSelectedEmployee?.user) {
          promises.push(this.updateEmployee(this.getSelectedEmployee.user))
        }

        const targetCustomerId = customerId || this.selectedCustomer?.user
        if (targetCustomerId) {
          promises.push(this.updateCustomer(targetCustomerId))
        }

        await Promise.all(promises)

        if (this.employeeInfos._id && this.customerInfos._id) {
          this.step = 3
        } else if (this.employeeInfos._id) {
          this.step = 2
        } else {
          this.step = 1
        }
      } catch (error) {
        this.$toast.error("Ein Fehler ist beim Initialisieren aufgetreten.")
        this.close()
      } finally {
        this.initializing = false
      }
    },
    newAccountRegistered() {
      this.showRegisterDialog = false
      this.$toast.success("Neuer Account erfolgreich erstellt. Du kannst den Kunden nun auswählen")
    },
    createRoodyAccount() {
      this.showRegisterDialog = true
    },
    addCourse(course) {
      this.recommendedCourse = course
      this.courseKey++ // force re-render if needed
    },
    validateStep1() {
      return this.employeeInfos._id && this.employeeInfos._id.length > 4
    },
    validateStep2() {
      return this.customerInfos._id && this.customerInfos._id.length > 4
    },
    validateStep3() {
      return this.reason && this.reason.length > 2 && this.notes && this.notes.length > 2 && this.location && this.location.length > 2
    },
    nextStep(currentStep) {
      if (currentStep === 1 && this.validateStep1()) {
        this.step = 2
      } else if (currentStep === 2 && this.validateStep2()) {
        this.step = 3
      } else {
        this.$toast.error("Bitte wähle eine Person aus.")
      }
    },
    prevStep() {
      this.step -= 1
    },
    async save() {
      if (!this.validateStep3()) {
        this.$toast.error("Bitte fülle alle Felder aus.")
        return
      }
      this.saving = true
      let entry = {
        user: this.customerInfos._id,
        employee: this.employeeInfos._id,
        date: this.$moment().format(),
        shareContactInfo: this.shareContactInfo,
        reason: this.reason,
        location: this.location,
        notes: this.notes,
      }

      // --- NEUE DATEN ZUM ENTRY-OBJEKT HINZUFÜGEN ---
      if (this.showAppointmentFields && this.appointmentMade === "ja" && this.appointmentDate && this.appointmentTime) {
        entry.appointmentDate = this.$moment(`${this.appointmentDate} ${this.appointmentTime}`).format()
      }

      if (this.reason === "Zusatzpakete pushen") {
        entry.additionalPackages = this.selectedPackages
      }

      if (this.reason === "Kursempfehlung" && this.recommendedCourse) {
        entry.recommendedCourse = this.recommendedCourse._id
      }

      try {
        await api.saveCustomerInteraction(entry)
        this.$emit("interactionCreated")
        this.$toast.success("Interaktion erfolgreich gespeichert")
        this.close()
      } catch (e) {
        this.$toast.error("Fehler beim Speichern")
      } finally {
        this.saving = false
      }
    },
    reset() {
      this.employeeInfos = { _id: null }
      this.customerInfos = { _id: null }
      this.reason = null
      this.notes = null
      this.location = null
      this.shareContactInfo = false

      // --- NEUE FELDER ZURÜCKSETZEN ---
      this.appointmentMade = null
      this.appointmentDate = null
      this.appointmentTime = null
      this.selectedPackages = []
      this.recommendedCourse = null

      this.step = 1
      return Promise.resolve()
    },
    close() {
      this.showDialog = false
    },
    async updateEmployee(id) {
      try {
        let employeeManager = await api.getUserForManager(id)
        this.employeeInfos = {
          _id: id,
          firstName: employeeManager.vorname,
          lastName: employeeManager.nachname,
          email: employeeManager.email,
        }
      } catch (e) {
        this.$toast.error("Fehler beim Laden des Trainer-Accounts")
        throw e
      }
    },
    async updateCustomer(id) {
      try {
        let employeeManager = await api.getUserForManager(id)
        this.customerInfos = {
          _id: id,
          firstName: employeeManager.vorname,
          lastName: employeeManager.nachname,
          email: employeeManager.email,
        }
      } catch (e) {
        this.$toast.error("Fehler beim Laden des Kunden-Accounts")
        throw e
      }
    },
  },
}
</script>

<style scoped>
.glass-dialog-card {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(15px) saturate(180%);
  -webkit-backdrop-filter: blur(15px) saturate(180%);
  border-radius: 20px !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.15) !important;
  padding: 16px;
}

.transparent-stepper {
  background: transparent !important;
  box-shadow: none !important;
}

.transparent-stepper .v-stepper__header {
  box-shadow: none !important;
}

.v-stepper__content {
  padding: 24px 8px 16px 8px !important;
}
</style>
